import { Component, EventEmitter, Output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'lib-web-shared-ui-location-search',
  imports: [FormsModule, MatFormFieldModule, MatInputModule, MatIconModule, MatButtonModule],
  templateUrl: './lib-location-search.component.html',
  styleUrl: './lib-location-search.component.scss',
})
export class LibLocationSearchComponent {
  searchBranchNameSignal = signal<string>('');

  @Output() emitSearchInput = new EventEmitter();
  @Output() emitSearchButton = new EventEmitter();

  onClickSearchInput() {
    this.emitSearchInput.emit(this.searchBranchNameSignal());
  }

  onClickSearchButton() {
    this.searchBranchNameSignal.set('');
    this.emitSearchButton.emit();
  }
}
